import React, { useContext } from 'react'
import ReactDOM from 'react-dom'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentInner } from '../../layout/Content'
import StockOutListInnerStyle from './css/StockOutListInnerStyle'
import StockOutItemController from '../stockoutitem/StockOutItemController'
import { stockOutListControllerContext } from '../stockoutlist/StockOutListController'
import { appContext } from '../../../App'

function StockOutListInner() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const stockOutListController = useContext(stockOutListControllerContext)
  const { stockOutList, sortStockOutListBy, stockOutListSorted,
    addSelectedSOId, removeSelectedSOId, foundUnpostedSO, getStockOutByID,
    reloadStockOutList } = stockOutListController
  const [selectAll, setSelectAll] = stockOutListController.selectAll
  const startSlice = stockOutListController.startSlice[0]
  const endSlice = stockOutListController.endSlice[0]
  const [sortBy, setSortBy] = stockOutListController.sortBy

  const onClickListItem = async (e) => {
    if (e.target.type === 'checkbox') return
    const so_id= e.target.closest('.so-item').id
    const stockOutItem = await getStockOutByID(app, so_id) // get the latest stockout record

    const showMessageBox = () => {
      const onClick = async () => {
        await reloadStockOutList()
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }
      ReactDOM.render (
        <ModalWindow id='mw-parent' height='20' width='25' header='SO Not Found' footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div>The StockOut file/record no longer exist.</div>
            </div>
            <div className='button-container'>
              <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    // Check if stockOuItem still available/exist
    if (stockOutItem) setContent(<StockOutItemController stockOutItem={stockOutItem}/>)
    else { showMessageBox() }
  }

  const onClickSelectAll = (e) =>  { setSelectAll(!selectAll) }

  const onClickSort = (e) => {
    const header = e.target.closest('.title-header')
    sortStockOutListBy(header.id)
    setSortBy(header.id)
  }

  const onClickCheckBox = (e) => {
    const so_id = e.target.closest('.so-item').id
    const checked = e.target.checked
    if (checked) addSelectedSOId(so_id)
    else removeSelectedSOId(so_id)
  }

  let userCanAdd = true
  if (app.client.signed_in !== 'admin') userCanAdd = app.client.signed_in.user_access.stockout_add_new

  return (
    <ContentInner>
      <div className='table-stock-out-container'>
        <table className="table striped-table">
          <thead>
            <tr>
              <th>
                <div
                  id='date_released'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Date Released</div>
                  <span>
                    {
                      (sortBy === 'date_released') ?
                        (stockOutListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='source_warehouse'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Source Warehouse</div>
                  <span>
                    {
                      (sortBy === 'source_warehouse') ?
                        (stockOutListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='dest_warehouse'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Destination Warehouse</div>
                  <span>
                    {
                      (sortBy === 'dest_warehouse') ?
                        (stockOutListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='prepared_by'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Prepared By</div>
                  <span>
                    {
                      (sortBy === 'prepared_by') ?
                        (stockOutListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='reference_code'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Reference</div>
                  <span>
                    {
                      (sortBy === 'reference_code') ?
                        (stockOutListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              <th>
                <div
                  id='status'
                  onClick={onClickSort}
                  className='title-header'>
                  <div>Status</div>
                  <span>
                    {
                      (sortBy === 'status') ?
                        (stockOutListSorted) ?
                          <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-up'/>
                          : <FontAwesomeIcon className='fa-icon-sort' icon='sort-numeric-down-alt'/>
                        : ''
                    }
                  </span>
                </div>
              </th>
              {
                (userCanAdd)
                ? <th className='empty-header' style={{ display: (foundUnpostedSO) ? 'flex' : 'none', paddingTop: '18px' } }>
                    <button
                      type="button"
                      className='pospro-action-btn toolbar-btn'
                      id="select-all-btn"
                      title="Select/Unselect all selectable items on the list"
                      onClick={onClickSelectAll}>
                      {
                        (selectAll) ? (<span style={{fontSize: '1rem' }}><FontAwesomeIcon icon='check-square'/></span>)
                        : (<span style={{fontSize: '1rem'}}><FontAwesomeIcon icon='square'/></span>)
                      }
                    </button>
                  </th>
                : null
              }
            </tr>
          </thead>
          {
            stockOutList.slice(startSlice, endSlice).map((stockOut, index) => (
              <tbody key={stockOut._id} id={index}>
                <tr className='so-item' onClick={onClickListItem} id={stockOut._id}>
                  {/* <td>{`${simpleDateString(new Date(stockOut.date_released))} ${stockOut.client_timezone}`}</td> */}
                  <td>{new Date(stockOut.date_released).toLocaleString("en-us", { timeZone: stockOut.client_timezone }).split(',')[0]} {stockOut.client_timezone}</td>
                  <td>{stockOut.source_warehouse.name}</td>
                  <td>{stockOut.dest_warehouse.name}</td>
                  <td>{stockOut.prepared_by}</td>
                  <td>{stockOut.reference_code}</td>

                  <td><span className={`status ${stockOut.status.toLowerCase()}`}>{stockOut.status}</span></td>
                  {
                    (foundUnpostedSO && userCanAdd)
                    ? <td>{
                        (stockOut.status === 'Unposted')
                        ? <input type='checkbox' onClick={onClickCheckBox} className='so-checkbox'/>
                        : ''
                      }</td>
                    : null
                  }

                </tr>
              </tbody>
            ))
          }
        </table>
      </div>
      <StockOutListInnerStyle />
    </ContentInner>
  )
}

export default React.memo(StockOutListInner)
